<template>
  <base-amount
    :unit="currency"
    :value="parseFloat(value)"
    :settings="{ minimumFractionDigits: 2, maximumFractionDigits: 2 }"
  ></base-amount>
</template>

<script>
import BaseAmount from '@kanrisha/components/Elements/Amount/BaseAmount';

export default {
  components: {
    BaseAmount,
  },
  props: {
    currency: { type: String, default: '&euro;' },
    value: { type: [Number, String], default: 0.0 },
    schema: { type: String, default: '{{ unit }} {{ value }}' },
  },
  setup() {
    return {};
  },
};
</script>
